import styled from "styled-components";

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const FooterStripWrapper = styled.div`
  margin: 0 -16px -16px;
`;

export const FooterStripGradientBorder = styled.div`
  height: 2px;
  background: linear-gradient(
    90deg,
    rgba(174, 95, 20, 0) 0%,
    #c69b1d 50%,
    rgba(214, 193, 35, 0) 100%
  );
`;

export const FooterStripContent = styled.div`
  background: linear-gradient(-19deg, #ffffff 0.6%, #fff6e3 99.8%);
  padding: 12px 20px;
  text-align: center;
  font-size: 12px;
  font-weight: 900;
  color: #000000;
`;

export const Banner = styled.div`
  border-radius: 8px;
  background: #fff5de;
  color: #533b00;
  border: 1px solid #f3dea7;
  font-size: 12px;
  padding: 8px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const BannerClose = styled.button`
  border: none;
  background: transparent;
  color: #9ca3af;
  font-size: 16px;
`;

export const FieldError = styled.p`
  margin: 4px 0 0;
  font-size: 12px;
  color: #c62828;
`;

export const ValidationToast = styled.div`
  position: fixed;
  left: 50%;
  top: max(12px, env(safe-area-inset-top));
  transform: translateX(-50%);
  z-index: 10050;
  max-width: calc(100% - 32px);
  padding: 12px 16px;
  border-radius: 8px;
  background: #111;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
`;

